/**
 * Helpers de detección de lote — Tierra.
 * Centralizados para que la ficha y el mapa usen la MISMA regla.
 *
 * Regla de honestidad (Gonzalo, 2026-07-17 + Fase 4a 2026-07-24):
 * Un lote está "con protección/condición especial" si su
 * `caracter_urbanistico` contiene (case-insensitive, con o sin tilde)
 * alguna de las 4 keywords: PRESERVACIÓN · HISTÓRIC · PATRIMONIAL ·
 * PAISAJÍSTIC. Es una condición A VERIFICAR — NO se afirma que "no se
 * puede construir".
 */

export const PROTECCION_REGEX = /PRESERVACI[ÓO]N|HIST[ÓO]RIC|PATRIMON|PAISAJ[ÍI]STIC/;

/** True si el lote dispara la alerta de protección/condición especial. */
export const tieneProteccionEspecial = (lote) =>
  PROTECCION_REGEX.test(String(lote?.caracter_urbanistico || "").toUpperCase());
